import React from "react";
import PropTypes from "prop-types";
import RuleColoredPill from "./RuleColoredPill";

const Criteria = ({ item, criteriaMet }) => {
  if (item && Object.keys(item || {}).length) {
    const evidences = criteriaMet ? item.evidence_met : item.evidence_not_met;
    if (evidences && Array.isArray(evidences) && evidences.length > 0) {
      return (
        <div className="varsome-inner-container">
          <h6 className="tw-font-semibold tw-mb-0">
            {criteriaMet ? `Criteria Met` : `Criteria Not Met`}
          </h6>
          {evidences.map((evidence) => {
            return (
              <RuleColoredPill
                key={evidence}
                metCriteria={criteriaMet}
                rule={evidence}
              />
            );
          })}
        </div>
      );
    }
  }
  return null;
};

Criteria.propTypes = {
  item: PropTypes.shape({
    approval_date: PropTypes.string,
    disease: PropTypes.string,
    evidence_met: PropTypes.arrayOf(PropTypes.string),
    evidence_not_met: PropTypes.arrayOf(PropTypes.string),
    expert_panel: PropTypes.string,
    guideline: PropTypes.string,
    mode_of_inheritance: PropTypes.string,
    mondo_id: PropTypes.string,
    pathogenicity: PropTypes.string,
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    published_date: PropTypes.string,
    repo_link: PropTypes.string,
    retracted: PropTypes.string,
    summary: PropTypes.string,
    version: PropTypes.string,
  }),
  criteriaMet: PropTypes.bool,
};

Criteria.defaultProps = {
  item: {},
  criteriaMet: false,
};

export default Criteria;
